import React, { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../../services/api';
import AdminSummaryCards from '../../components/admin/AdminSummaryCards';
import AdminLogoHeader from '../../components/admin/AdminLogoHeader';

const AdminDashboard = () => {
  const [metrics, setMetrics] = useState({
    pending_onboarding: 0,
    total_deposits: 0,
    total_withdrawals: 0,
    kyc_approved: 0,
  });

  const loadMetrics = useCallback(async () => {
    try {
      const data = await api.adminFetchMetrics();
      setMetrics({
        pending_onboarding: Number(data?.pending_onboarding || 0),
        total_deposits: Number(data?.total_deposits || 0),
        total_withdrawals: Number(data?.total_withdrawals || 0),
        kyc_approved: Number(data?.kyc_approved || 0),
      });
    } catch (err) {
      console.error('admin metrics', err);
    }
  }, []);

  useEffect(() => {
    loadMetrics();
  }, [loadMetrics]);

  const stats = useMemo(() => ({
    pendingOnboarding: metrics.pending_onboarding,
    approvedDeposits: metrics.total_deposits,
    approvedWithdrawals: metrics.total_withdrawals,
    kycApproved: metrics.kyc_approved,
  }), [metrics]);

  return (
    <div className="min-h-screen bg-slate-50">
      <AdminLogoHeader />
      <div className="max-w-7xl mx-auto space-y-6 p-6">
        <AdminSummaryCards stats={stats} />
      </div>
    </div>
  );
};

export default AdminDashboard;
